module.exports = __webpack_public_path__ + "static/8-a2cf40341b3b409c693a5dd7d7de302f.jpg";